import { HealthScoreMetricLabels, GlobalBusinessHealthMetrics } from 'pages/Insights/BusinessHealth/types';
import SalesRatioValue from '../../HealthMetricCard/SalesRatioValue';

const buildSalesRatioValue = (
    metrics?: GlobalBusinessHealthMetrics,
    labels?: Record<string, HealthScoreMetricLabels>,
) => {
    const wins = metrics?.opportunities_won?.current;
    const lost = metrics?.opportunities_lost?.current;
    const winsOk = wins !== undefined && Number.isFinite(wins);
    const lostOk = lost !== undefined && Number.isFinite(lost);
    if (!winsOk || !lostOk) {
        return '—';
    }
    return (
        <SalesRatioValue
            wins={wins}
            lost={lost}
            labels={{
                won: labels?.opportunities_won?.label_short?.toLowerCase(),
                closed: labels?.opportunities_lost?.label_short?.toLowerCase(),
            }}
        />
    );
};

export default buildSalesRatioValue;
